<div class="main-container" style="margin: auto">
    <div class="row page-header-actions">
        <button mat-icon-button [routerLink]="['/flujo-credito-light']" matTooltip="Volver a Flujo de Crédito Light">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="page-content">
        <h1 class="mat-section-title">Flujo de Crédito Light</h1>
        <label class="mat-sub-title mb-5" for="">Ficha cliente</label>

        <ng-container *ngIf="validaClave('modelo01')">
            <app-plantilla-salfa-fc-light [idTransaccion]="currentIdTransaccion" [generalReport]="generalReport"></app-plantilla-salfa-fc-light>
        </ng-container>

    </div>
</div>